<div class="email-compose-card" [formGroup]="emailForm">
    <!-- FROM -->
    <!-- <div class="field-row" style="position: relative;">
        <div class="field-prefix">
            <span class="field-label">From</span>
            <span class="field-separator">|</span>
        </div>
        <input type="text" formControlName="from" class="field-input" placeholder="Enter sender email"
            (input)="onFromInputChange($event)" (blur)="hideFromSuggestions()" />

        <div class="email-suggestions" *ngIf="showFromSuggestions && filteredFromEmails.length > 0">
            <div class="suggestion-item" *ngFor="let email of filteredFromEmails" (click)="selectFromEmail(email)">
                {{ email }}
            </div>
        </div>
    </div> -->
    <!-- TO -->
    <div class="field-row">
        <div class="field-prefix">
            <span class="field-label">To</span>
            <span class="field-separator">|</span>
        </div>
        <input type="text" formControlName="to" class="field-input" placeholder="Enter recipient email" />
    </div>

    <!-- CC -->
    <div class="field-row">
        <div class="field-prefix">
            <span class="field-label">CC</span>
            <span class="field-separator">|</span>
        </div>
        <input type="text" formControlName="cc" class="field-input" placeholder="Enter CC email" />
    </div>

    <!-- SUBJECT -->
    <div class="field-row">
        <div class="field-prefix">
            <span class="field-label">Subject</span>
            <span class="field-separator">|</span>
        </div>
        <input type="text" formControlName="subject" class="field-input" placeholder="Enter subject" />

        <button type="button" class="link-btn browse-btn" (click)="openMailTemplates()">
            Browse templates
        </button>
    </div>

    <!-- BODY -->
    <div class="body-row">
        <div class="body-textarea" contenteditable="true" #bodyEditor (input)="onBodyInput()"
            (mouseup)="onEditorSelectionChange()" (keyup)="onEditorSelectionChange()"></div>
    </div>

    <div class="footer-above-row" *ngIf="combinedAttachments.length > 0">
        <div class="footer-toolbar-popup">
            <!-- make the uploaded files scrollable horizontally -->
            <div class="uploaded-files">
                <div *ngFor="let file of combinedAttachments" class="file-item d-flex align-items-center">
                    <mat-icon style="line-height: 24px;">insert_drive_file</mat-icon>

                    <!-- Template Attachment -->
                    <ng-container *ngIf="file.isTemplateFile">
                        <a [href]="file.url" target="_blank">{{ file.name }}</a>
                    </ng-container>

                    <!-- Uploaded File -->
                    <ng-container *ngIf="!file.isTemplateFile">
                        {{ file.name }}
                        <button mat-icon-button (click)="removeUploadedFile(file.index)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>

    </div>

    <!-- FOOTER (toolbar + actions) -->
    <div class="footer-row">
        <!-- toolbar on the left -->
        <div class="footer-toolbar-popup" *ngIf="sec['_showFooterToolbar']" style="overflow-x: auto;">
            <div class="email-template-toolbar" style="flex-wrap: nowrap;">
                <!-- Format tools container with toggle -->
                <div class="email-template-tool-group format-tools-container">
                    <!-- Toggle button for format tools -->
                    <button type="button" class="border format-toggle-btn" matTooltipPosition="above"
                        [matTooltip]="showFormatTools ? 'Hide format tools' : 'Show format tools'"
                        (mousedown)="$event.preventDefault()" (click)="toggleFormatTools()"
                        [class.active]="showFormatTools" title="Format tools">
                        <span class="material-icons">{{ showFormatTools ? 'close' : 'rtt' }}</span>
                    </button>

                    <!-- Sliding format tools -->
                    <div class="format-tools-slider" [class.show]="showFormatTools">
                        <!-- Heading selector -->
                        <div class="email-template-tool-group" matTooltipPosition="above" matTooltip="Font size">
                            <select class="email-template-heading-selector" [value]="getFooterHeading(sec)"
                                (change)="onFooterHeadingChange(sec, $event)" (mousedown)="$event.preventDefault()">
                                <option value="p">Normal</option>
                                <option value="h1">Heading 1</option>
                                <option value="h2">Heading 2</option>
                                <option value="h3">Heading 3</option>
                            </select>
                        </div>

                        <div class="email-template-divider"></div>

                        <!-- Bold / Italic / Underline / Strike -->
                        <div class="email-template-tool-group">
                            <button type="button" class="border" matTooltipPosition="above" matTooltip="Bold"
                                [class.active]="isFooterBold(sec)" (mousedown)="$event.preventDefault()"
                                (click)="toggleFooterBold(sec)" title="Bold">
                                <span class="material-icons">format_bold</span>
                            </button>
                            <button type="button" class="border" matTooltipPosition="above" matTooltip="Italic"
                                [class.active]="isFooterItalic(sec)" (mousedown)="$event.preventDefault()"
                                (click)="toggleFooterItalic(sec)" title="Italic">
                                <span class="material-icons">format_italic</span>
                            </button>
                            <button type="button" class="border" matTooltipPosition="above" matTooltip="Underline"
                                [class.active]="isFooterUnderline(sec)" (mousedown)="$event.preventDefault()"
                                (click)="toggleFooterUnderline(sec)" title="Underline">
                                <span class="material-icons">format_underlined</span>
                            </button>
                            <button type="button" class="border" matTooltipPosition="above" matTooltip="Strikethrough"
                                [class.active]="isFooterStrike(sec)" (mousedown)="$event.preventDefault()"
                                (click)="toggleFooterStrike(sec)" title="Strikethrough">
                                <span class="material-icons">strikethrough_s</span>
                            </button>
                        </div>

                        <div class="email-template-divider"></div>

                        <!-- Alignment -->
                        <div class="email-template-tool-group">
                            <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Left"
                                [class.active]="isFooterAlign(sec, 'left')" (mousedown)="$event.preventDefault()"
                                (click)="setFooterAlign(sec, 'left')" title="Align Left">
                                <span class="material-icons">format_align_left</span>
                            </button>
                            <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Center"
                                [class.active]="isFooterAlign(sec, 'center')" (mousedown)="$event.preventDefault()"
                                (click)="setFooterAlign(sec, 'center')" title="Align Center">
                                <span class="material-icons">format_align_center</span>
                            </button>
                            <button type="button" class="border" matTooltipPosition="above" matTooltip="Align Right"
                                [class.active]="isFooterAlign(sec, 'right')" (mousedown)="$event.preventDefault()"
                                (click)="setFooterAlign(sec, 'right')" title="Align Right">
                                <span class="material-icons">format_align_right</span>
                            </button>
                        </div>

                        <div class="email-template-divider"></div>

                        <!-- Font / background colors -->
                        <div class="email-template-tool-group email-template-color-group">
                            <!-- Text color -->
                            <div class="email-template-color-wrapper border" title="Text Color"
                                matTooltipPosition="above" matTooltip="Font color"
                                (mousedown)="$event.preventDefault()">
                                <span class="material-icons email-template-color-icon"
                                    [style.color]="getFooterTextColor(sec)">
                                    format_color_text
                                </span>
                                <input type="color" [value]="getFooterTextColor(sec)"
                                    (change)="onFooterTextColorChange(sec, $event)" />
                            </div>

                            <!-- Background color (highlight) -->
                            <div class="email-template-color-wrapper border" title="Background Color"
                                matTooltipPosition="above" matTooltip="Background color"
                                (mousedown)="$event.preventDefault()">
                                <span class="material-icons email-template-color-icon"
                                    [style.color]="getFooterBgColor(sec)">
                                    border_color
                                </span>
                                <input type="color" [value]="getFooterBgColor(sec)"
                                    (change)="onFooterBgColorChange(sec, $event)" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="email-template-divider"></div>

                <!-- Table tools (advanced) -->
                <div class="email-template-tool-group table-tools-container">
                    <!-- Toggle button for table tools -->
                    <button type="button" class="border table-toggle-btn" matTooltipPosition="above"
                        [matTooltip]="showTableTools ? 'Hide table tools' : 'Show table tools'"
                        (mousedown)="$event.preventDefault()" (click)="toggleTableTools()"
                        [class.active]="showTableTools" title="Table tools">
                        <span class="material-icons">{{ showTableTools ? 'close' : 'grid_on' }}</span>
                    </button>

                    <!-- Sliding table tools -->
                    <div class="table-tools-slider" [class.show]="showTableTools">
                        <button type="button" class="border" matTooltipPosition="above" matTooltip="Insert table"
                            (mousedown)="$event.preventDefault()" (click)="insertDefaultTable()" title="Insert table">
                            <span class="material-icons">add_box</span>
                        </button>

                        <button type="button" class="border" matTooltipPosition="above" matTooltip="Insert row above"
                            (mousedown)="$event.preventDefault()" (click)="insertRowAbove()" title="Insert row above">
                            <span class="material-icons">border_top</span>
                        </button>

                        <button type="button" class="border" matTooltipPosition="above" matTooltip="Insert row below"
                            (mousedown)="$event.preventDefault()" (click)="insertRowBelow()" title="Insert row below">
                            <span class="material-icons">border_bottom</span>
                        </button>

                        <button type="button" class="border" matTooltipPosition="above" matTooltip="Insert column left"
                            (mousedown)="$event.preventDefault()" (click)="insertColumnLeft()"
                            title="Insert column left">
                            <span class="material-icons">border_left</span>
                        </button>

                        <button type="button" class="border" matTooltipPosition="above" matTooltip="Insert column right"
                            (mousedown)="$event.preventDefault()" (click)="insertColumnRight()"
                            title="Insert column right">
                            <span class="material-icons">border_right</span>
                        </button>

                        <button type="button" class="border" matTooltipPosition="above" matTooltip="Delete row"
                            (mousedown)="$event.preventDefault()" (click)="deleteRow()" title="Delete row">
                            <span class="material-icons">horizontal_rule</span>
                        </button>

                        <button type="button" class="border" matTooltipPosition="above" matTooltip="Delete column"
                            (mousedown)="$event.preventDefault()" (click)="deleteColumn()" title="Delete column">
                            <span class="material-icons">view_column</span>
                        </button>

                        <button type="button" class="border" matTooltipPosition="above" matTooltip="Delete table"
                            (mousedown)="$event.preventDefault()" (click)="deleteTable()" title="Delete table">
                            <span class="material-icons">table_rows</span>
                        </button>

                        <div class="email-template-divider"></div>

                        <!-- TD / TH background color controls -->
                        <div class="email-template-color-group">
                            <!-- TH background -->
                            <div class="email-template-color-wrapper border" title="Header cell background"
                                matTooltipPosition="above" matTooltip="TH background"
                                (mousedown)="$event.preventDefault()">
                                <span class="material-icons email-template-color-icon">
                                    border_top
                                </span>
                                <input type="color" (change)="setThBackground($event)" />
                            </div>

                            <!-- TD background -->
                            <div class="email-template-color-wrapper border" title="Cell background"
                                matTooltipPosition="above" matTooltip="TD background"
                                (mousedown)="$event.preventDefault()">
                                <span class="material-icons email-template-color-icon">
                                    border_style
                                </span>
                                <input type="color" (change)="setTdBackground($event)" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="email-template-divider"></div>
                <div class="email-template-tool-group table-tools-container">
                    <button type="button" class="border table-toggle-btn" matTooltipPosition="above"
                        matTooltip="Attach files" (click)="fileInput.click()">
                        <mat-icon>attach_file</mat-icon>
                    </button>
                    <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)" multiple />
                </div>

            </div>
        </div>

        <!-- actions on the right -->
        <div class="actions">
            <!-- <button type="button" style="width: max-content;" class="link-btn" (click)="onSaveTemplate()">
                Save As Template
            </button> -->

            <button type="button" style="width: max-content;" class="primary-btn" (click)="onSend()">
                Send Email
                <span class="arrow">➤</span>
            </button>
        </div>
    </div>
</div>